import type React from 'react'
import { RiArrowDownLine, RiArrowUpLine } from '@remixicon/react'
import PropTypes from 'prop-types'

type DataHeadItem = {
    id: string | number
    title: string
    state?: 'asc' | 'desc'
    sortable?: boolean
    className?: string
}

type AppTableProps = {
    dataHead: DataHeadItem[]
    onSortColumn?: (order: 'asc' | 'desc', title: string) => void
    colorHeader?: string
    children: React.ReactNode
}

export const AppTable: React.FC<AppTableProps> = ({
    dataHead,
    onSortColumn,
    colorHeader = '',
    children,
}) => {
    return (
        <div className="w-full overflow-x-auto overflow-hidden rounded-lg border border-[#e2e2e2]">
            <table className="w-full movile:min-w-[890px] tablet:min-w-[890px] ">
                <thead className="space-y-3 w-full overflow-hidden bg-[#F1F5F9] py-[10px]">
                    <tr className={`${colorHeader} h-9`}>
                        {dataHead.map((item, index) => {
                            const isSortable = item.sortable === true
                            const classNameValue =
                                item.className !== null &&
                                item.className !== undefined &&
                                item.className !== ''
                                    ? item.className
                                    : 'text-center text-sm font-medium w-auto'

                            return (
                                <th
                                    key={item.id}
                                    onClick={() =>
                                        isSortable &&
                                        onSortColumn &&
                                        onSortColumn(
                                            item.state === 'desc'
                                                ? 'asc'
                                                : 'desc',
                                            item.title
                                        )
                                    }
                                    className={`${classNameValue} ${
                                        isSortable ? 'cursor-pointer' : ''
                                    } ${index === 0 && 'rounded-l-lg '} ${
                                        index === dataHead.length - 1 &&
                                        'rounded-r-lg'
                                    } `}
                                >
                                    {item.title}
                                    {isSortable && (
                                        <button className={'ml-1'}>
                                            {item.state === 'desc' ? (
                                                <RiArrowUpLine
                                                    size={16}
                                                    className="relative top-[2px]"
                                                />
                                            ) : (
                                                <RiArrowDownLine
                                                    size={16}
                                                    className="relative top-[2px]"
                                                />
                                            )}
                                        </button>
                                    )}
                                </th>
                            )
                        })}
                    </tr>
                </thead>

                {children}
            </table>
        </div>
    )
}

AppTable.propTypes = {
    dataHead: PropTypes.array.isRequired,
    children: PropTypes.element.isRequired,
    onSortColumn: PropTypes.func,
    colorHeader: PropTypes.string,
}
